<!-- 获取时间段进场记录接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"parkCode":"2KNTYVWC","channelId":"123ABC","carCode":"粤A12345","operatorTime":"20171015000000","plateColor":1,"carSize":"1"},
            responseCode: 	{
                "data": {
                    "passOrNot": 1,
                    "voice": "欢迎光临",
                    "show": "欢迎光临",
                    "preCarInJson":""
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车辆进出通道权限",
                t_url: this.commonUrls.test+"getChannelPermission",
                p_url: this.commonUrls.prod+"getChannelPermission",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'channelId', info2: '是', info3: 'String', info4: '通道自定义编码' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌' },
                        { info1: 'operatorTime', info2: '是', info3: 'String', info4: '请求时间，yyyyMMddHHmmss' },
                        { info1: 'plateColor', info2: '是', info3: 'Integer', info4: '车牌颜色,云停车场必填' },
                        { info1: 'carSize', info2: '否', info3: 'Integer', info4: '大小车,云停车场必填' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                         { info1: 'passOrNot', info2: '是', info3: 'Integer', info4: '是否可通行（0不放行，1放行）' },
                        { info1: 'voice', info2: '是', info3: 'String', info4: '语音' },
                        { info1: 'show', info2: '是', info3: 'String', info4: '屏显' },
                        { info1: 'preCarInJson', info2: '否', info3: 'String', info4: '用于vems补录的信息' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/getChannelPermission.vue